import { Setor, Vendedor } from '@shared/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultRequest } from '@shared/utils/consult-request';
import { VisitasService } from '@modules/visitas/services/visitas.service';

@Component({
  selector: 'app-vendedor-combo',
  templateUrl: './vendedor-combo.component.html',
  styleUrls: ['./vendedor-combo.component.scss'],
  providers: [VisitasService]
})
export class VendedorComboComponent implements OnInit {
  @Input() vendedor: Vendedor;
  @Output() vendedorChange = new EventEmitter<Vendedor>();

  vendedoresRequest = new ConsultRequest<Vendedor[]>();

  private _setor: Setor = null;

  constructor(
    private visitService: VisitasService,
  ) { }

  ngOnInit() {
  }

  get setor(){
    return this._setor;
  }

  @Input()
  set setor(value: Setor | null){
    this.vendedoresRequest.reset()
    this.vendedoresRequest.cancel()

    if(!value){
      this._setor = null;
    }else{
      this._setor = value;
      this.getVendedores()
    }
  }

  handleVendedorChange(){
    this.vendedorChange.emit(this.vendedor)
  }

  // metodos privados

  private getVendedores() {
    console.log('setor', this.setor)
    if(!this.setor){
      return;
    }

    this.vendedoresRequest.get(
      this.visitService.getVendedoresPorSetor(this.setor.codigo)
    )
  }

}
